import Eastern6Attic1 from '../Eastern/Grand Eastern 6 Attic (1).webp'
import Eastern6Attic2 from '../Eastern/Grand Eastern 6 Attic (2).webp'


const Eastern6Atticimages =[
Eastern6Attic1,Eastern6Attic2
]

export default Eastern6Atticimages;